module.exports = __webpack_public_path__ + "assets/img/zoom_mobile.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zoom_mobile.png
// module id = 1995
// module chunks = 0